import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { MessageService } from '@services/helpers/message-service/message.service';

@Injectable()
export class ProductPackagesDataServiceProvider {
	updateProductPackageSubject: Subject<any> = new Subject();

	constructor(
		private http: HttpClient,
		private messageService: MessageService
	) {}

	// 	TODO QT - need refactor
	getDefaultIntroductionText(): Observable<any> {
		const url = '/api/user/v1/quote/template';
		return this.http.get(url).catch(error => {
			this.messageService.showDefaultErrorMessage(error);
			return error;
		});
	}

	updateDefaultIntroductionText(
		id: number,
		textToUpdate: any
	): Observable<any> {
		const url = `/api/user/v1/quote/template/${id}`;
		return this.http.post(url, textToUpdate).catch(error => {
			this.messageService.showDefaultErrorMessage(error);
			return error;
		});
	}

	getPackagesOrProducts(pageRequest: any): Observable<any> {
		const url = '/api/user/v1/product/template/list';
		return this.http.post(url, pageRequest).catch(error => {
			this.messageService.showDefaultErrorMessage(error);
			return error;
		});
	}

	deletePackagesOrProducts(id: number): Observable<any> {
		const url = `/api/user/v1/product/template/${id}`;
		return this.http.delete(url);
	}

	createPackagesOrProducts(productOrPackage: any): Observable<any> {
		const url = '/api/user/v1/product/template';
		return this.http.post(url, productOrPackage);
	}

	updatePackagesOrProducts(id, productOrPackage: any): Observable<any> {
		const url = `/api/user/v1/product/template/${id}${
			productOrPackage.updateLinked ? '?updateLinkedProducts=true' : ''
		}`;
		return this.http.post(url, productOrPackage);
	}

	getProductOrPackageTemplate(id: number): Observable<any> {
		const url = `/api/user/v1/product/template/${id}`;
		return this.http.get(url).catch(error => {
			this.messageService.showDefaultErrorMessage(error);
			return error;
		});
	}

	convertProductPackage(body: object): Observable<any> {
		const url = '/api/user/v1/product/template';
		return this.http.put(url, body).catch(error => {
			this.messageService.showDefaultErrorMessage(error);
			return error;
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./shared/services/settings/product-packages.data.service.ts